import { CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';

export function ScreenSuccess() {
  return (
    <div className="w-full max-w-[400px] text-center mt-12">
      <Card>
        <CardContent className="flex flex-col items-center gap-4 py-8">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
            <CheckCircle2 className="h-8 w-8 text-green-700" />
          </div>
          <h1 className="text-xl font-semibold text-brand-700">
            Document importé avec succès
          </h1>
          <p className="text-[15px] text-gray-500">
            Vous pouvez fermer cette page.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
